<template>
  <v-img
    v-show="$store.state.displayMap"
    :src="`./${logo}`"
    class="logo"
    contain
    style="position:fixed;"
    :style="$mq | mq({
      mobile: 'top:2%;width:40%;margin:0 30%;',
      tablet: 'bottom:2%;width:20%;margin:0 40%;',
      desktop: 'bottom:2%;width:10%;margin:0 45%;'
    })"
  />
</template>

<script>


export default {
  name: 'ClientLogo',
  data() {
    return {
      logo: this.$appConfig.logo,
      displayed: true,
    };
  },
  mounted() {},
};

</script>

<style scoped>
.logo {
  z-index: 9;
}
</style>
